import axios from 'axios';

const ROOT = 'api/v1/ssu-patients';

const PatientEncounterReviewApi = {
  getCraReview(ssuPatientId, patientEncounterId, hideLoader = true) {
    return axios.get(`${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/CRA`, { hideLoader });
  },

  getItemGroupRowSnapshotCraReviewState(ssuPatientId, patientEncounterId, itemGroupId, hideLoader = true) {
    return axios.get(`${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/CRA/item-groups/${itemGroupId}`, {
      hideLoader
    });
  },

  getLogSnapshotCraReviewState(ssuPatientId, patientEncounterId, itemGroupTemplateId, hideLoader = true) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/CRA/logs/${itemGroupTemplateId}`,
      { hideLoader }
    );
  },

  getLogCheckSnapshotSraReviewState(ssuPatientId, patientEncounterId, itemGroupTemplateId, hideLoader = true) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/CRA/log-check/${itemGroupTemplateId}`,
      { hideLoader }
    );
  },

  getSignedItemGroupRowSnapshotReviewState(
    ssuPatientId,
    patientEncounterId,
    itemGroupId,
    signatureId,
    hideLoader = true
  ) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/item-group/${itemGroupId}/signatures/${signatureId}`,
      { hideLoader }
    );
  },
  getSignedLogCheckSnapshotReviewState(ssuPatientId, patientEncounterId, itemGroupId, signatureId, hideLoader = true) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/log-check/${itemGroupId}/signatures/${signatureId}`,
      { hideLoader }
    );
  },
  getSignedLogSnapshotReviewState(
    ssuPatientId,
    patientEncounterId,
    itemGroupTemplateId,
    signatureId,
    hideLoader = true
  ) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/logs/${itemGroupTemplateId}/signatures/${signatureId}`,
      { hideLoader }
    );
  },

  getSmHistory(ssuPatientId, patientEncounterId, hideLoader = true) {
    return axios.get(`${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/SM/history`, {
      hideLoader
    });
  },

  getPiHistory(ssuPatientId, patientEncounterId, hideLoader = true) {
    return axios.get(`${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/PI/history`, {
      hideLoader
    });
  },

  getCraHistory(ssuPatientId, patientEncounterId, hideLoader = true) {
    return axios.get(`${ROOT}/${ssuPatientId}/encounters/${patientEncounterId}/review/CRA/history`, {
      hideLoader
    });
  },

  getItemGroupAnswerHistory(ssuPatientId, ssuEncounterId, itemGroupId, rowId, hideLoader = true) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${ssuEncounterId}/review/item-groups/${itemGroupId}/rows/${rowId}/answers/history`,
      { hideLoader }
    );
  },

  getItemGroupGeneralAnswerHistory(ssuPatientId, ssuEncounterId, itemGroupId, rowId, hideLoader = true) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${ssuEncounterId}/review/item-groups/${itemGroupId}/general-row/${rowId}/answers/history`,
      { hideLoader }
    );
  },

  getLogItemGroupAnswerHistory(
    ssuPatientId,
    ssuEncounterId,
    itemGroupTemplateId,
    itemGroupTemplateVersionId,
    rowId,
    hideLoader = true
  ) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${ssuEncounterId}/review/logs/${itemGroupTemplateId}/versions/${itemGroupTemplateVersionId}/rows/${rowId}/history-answers`,
      { hideLoader }
    );
  },

  getLogCheckAnswerHistory(ssuPatientId, ssuEncounterId, itemGroupTemplateId, hideLoader = true) {
    return axios.get(
      `${ROOT}/${ssuPatientId}/encounters/${ssuEncounterId}/review/log-check/${itemGroupTemplateId}/answers/history`,
      { hideLoader }
    );
  }
};

export default PatientEncounterReviewApi;
